import React, { Component } from "react";
import locales from "../../../_constants/locales";
import "../Styles/_OrderFetchErrorPage.css";

class OrderFetchErrorPage extends Component {
    render() {
        return (
            <section className="fit layout vertical center-center fetch-error-page">
                <h2>{locales[this.props.store[0]][this.props.language].FETCH_ERROR_PAGE.TITLE}</h2>
                <span className="thick-divider" />
                <p className="description">
                    {locales[this.props.store[0]][this.props.language].FETCH_ERROR_PAGE.DESCRIPTION}
                </p>
                <p className="help-message">
                    {`${locales[this.props.store[0]][this.props.language].FETCH_ERROR_PAGE.HELP_MESSAGE} `}
                    <a href={locales[this.props.store[0]][this.props.language].MISC.HELP_LINK} className="help-link">
                        {locales[this.props.store[0]][this.props.language].MISC.HELP_LINK}
                    </a>
                </p>
            </section>
        );
    }
}

export default OrderFetchErrorPage;



// WEBPACK FOOTER //
// ./src/views/Order/components/_OrderFetchErrorPage.jsx